module.exports = __webpack_public_path__ + "img/center2.decf616a.png";